import React, { useRef } from 'react';
import { focusChatbot } from '../utils/chatUtils'; // Adjust path as needed

const Hero = () => {
  const iframeRef = useRef(null);

  const handleAskWizbangClick = () => {
    focusChatbot(iframeRef.current); // Pass the iframe element directly
  };

  return (
    <section className="bg-white dark:bg-gray-900">
      <div className="container mx-auto px-6 py-16 text-center lg:py-20">
        <div className="lg:flex lg:items-center lg:justify-between">
          {/* Text Content Area */}
          <div className="lg:w-1/2 lg:text-left lg:pr-12">
            <h1 className="text-3xl font-bold text-text-primary dark:text-white lg:text-4xl">
              Stop Losing Leads. Start Converting Visitors.
            </h1>
            <p className="mt-4 text-lg text-text-secondary dark:text-gray-400">
              Wizbang uses your existing data to answer customer questions instantly, capture leads, and notify your team.
            </p>
            <div className="mt-8">
              <button 
                onClick={handleAskWizbangClick}
                type="button"
                className="px-6 py-3 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-primary rounded-lg hover:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50">
                Ready to learn more? Ask Wizbang!
              </button>
            </div>
          </div>

          {/* Chatbot iframe Area */}
          <div className="mt-12 lg:mt-0 lg:w-1/2 flex justify-center items-center">
            <iframe
              ref={iframeRef}
              id="wizbang-chat-iframe"
              src="https://rag.lucycuts.workers.dev/ui" 
              className="w-full max-w-md h-96 border border-gray-300 dark:border-gray-600 rounded-lg shadow-md"
              title="Wizbang Chat PoC"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 